<template>
  <footer class="app-footer">
    <span><a :href="SETTING['productLink']">{{ SETTING['product'] }}</a> &copy; 2021 {{ SETTING['system'] }}.</span>
    <span class="ml-auto">Powered by <a :href="SETTING['productLink']">{{ SETTING['product'] }}</a></span>
  </footer>
</template>
<script>
export default {
  name: 'c-footer'
}
</script>


// WEBPACK FOOTER //
// src/components/Footer.vue